import type {GlobalSportState} from "@atg-sport-shared/sportsbook-types-root";
import type {StatisticsState} from "@atg-sport-shared/sportsbook-types-statistics";

export const getStatistics: (state: GlobalSportState) => StatisticsState = (state) =>
    state.sportsbook.statistics;
